import { Select } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectOneSetting } from "../../../../../../util/store/selectors";
import { CERTAIN_TYPE, certainType, certainTypes } from "../../../../../../util/varibles/constants";
import { renderOpts } from '../../../../../../util/varibles/global';
import { PreferenceSetting } from "../../../../../../util/varibles/userSetting";
import styles from './style.module.scss';

interface IProps {
    value: any
    isLabel?: boolean
    className?: string

    onChange(value: any): void
}

const CertainSelect: React.FC<IProps> = (props) => {
    const isCertainty = useSelector(selectOneSetting(PreferenceSetting.SHOW_CERTAINTY))
    const { value = CERTAIN_TYPE.NONE } = props;
    if (!isCertainty)
        return <div />;

    const certain = value.length > 0 ? value : CERTAIN_TYPE.NONE;
    const { color = "", fontColor = "" } = certainType[certain] || {};


    return <div className={[styles.wrapper, props.className].join(' ')} >
        <div className='h-[32px] leading-[32px]'>Certainty:</div>
        <Select
            className={`w-[100px] h-[32px]`}
            styles={{
                root: {
                    "--bg-selected": color,
                    "--color-selected": fontColor,
                } as any
            }}
            value={certain}
            onChange={props.onChange}
            options={renderOpts(certainTypes)}
        />
    </div>;
};

export default CertainSelect;